export default {"src":"/_next/static/media/apple_logo.630b899f.svg","height":1000,"width":814,"blurWidth":0,"blurHeight":0};